import React, { useState, useEffect, useRef } from "react";
import FAQ from "./FAQ";
import Constants from "../constants/Constants";
import ManageMemberships from "./ManageMemberships";
import useDebounce from "../hooks/useDebounce";
import { useTheme } from "../context/theme.context";
import { Link } from "@reach/router";
const applicationServerPublicKey =
  "BOR6h4Ki7Z0bQ0KVpiWls6EOb04LLTZyDvZRMNLrdCiWlBKj19xNFa9QUKT-aKrS0fGOp08q_GsYJ_MwNPHF-40";
const urlB64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
const Profile = ({
  username,
  snapchat,
  dispatch,
  ogCommentName,
  email,
  push,
}) => {
  const [isEditing, setEditing] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isCNEditing, setIsCNEditing] = useState(false);
  const [swSupport, setSwSupport] = useState(false);
  const [name, setName] = useState(snapchat);
  const [commentName, setCommentName] = useState(ogCommentName);
  const snapchatName = useRef(snapchat);
  const commentNameRef = useRef(ogCommentName);
  const themeState = useTheme();
  const debouncedSetName = useDebounce(name, 500);
  const debouncedSetCommentName = useDebounce(commentName, 500);
  const serviceRef = useRef(null);
  const unsubscribeUser = () => {
    serviceRef.current.pushManager
      .getSubscription()
      .then(function(subscription) {
        if (subscription) {
          return subscription.unsubscribe();
        }
      })
      .catch(function(error) {
        console.log("Error unsubscribing", error);
      })
      .then(function() {
        fetch(`${Constants.API}user-does-not-want-push.php`, {
          credentials: "include",
        })
          .then((res) => res.json())
          .then((res) => {
            //handle
            dispatch({ type: "changePushNotifications", payload: "n" });
            setIsSubscribed(false);
          });
      });
  };
  const subscribeToPush = (sub) => {
    if (sub) {
      const data = JSON.stringify(sub);
      console.log(data);

      let formData = new FormData();
      formData.append("jString", data);
      fetch(`${Constants.API}user-wants-push.php`, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          "X-XSRF-Header": Constants.XSRF,
        },
      })
        .then((res) => res.json())
        .then((_) => {
          dispatch({ type: "changePushNotifications", payload: "y" });
        });
    }
  };
  const subscribeUser = () => {
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
    serviceRef.current.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey,
      })
      .then(function(subscription) {
        console.log("User is subscribed.");

        subscribeToPush(subscription);

        setIsSubscribed(true);
      })
      .catch(function(err) {
        console.log("Failed to subscribe the user: ", err);
        console.log(err.message);
      });
  };
  const handleChangeEmailNotes = () => {
    const newVal = email === "y" ? "n" : "y";

    dispatch({ type: "changeNotesEmail", payload: newVal });
    const formData = new FormData();
    formData.append("notify", newVal);
    fetch(`${Constants.API}update-dm-note-pref.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
    });
  };
  useEffect(() => {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      setSwSupport(true);
      navigator.serviceWorker
        .register("/vip/sw.js", { scope: "/vip/profile" })
        .then(function(swReg) {
          console.log("Service Worker is registered", swReg);
          serviceRef.current = swReg;
          serviceRef.current.pushManager
            .getSubscription()
            .then(function(subscription) {
              const truthy = !(subscription === null);
              if (truthy) {
                setIsSubscribed(true);
                console.log("User IS subscribed.", subscription);
              } else {
                console.log("User is NOT subscribed.");
              }
            });
        })
        .catch(function(error) {
          console.error("Service Worker Error", error);
        });
    }
  }, []);
  useEffect(() => {
    if (snapchatName.current !== debouncedSetName) {
      snapchatName.current = debouncedSetName;
      let formData = new FormData();
      formData.append("snapchat", debouncedSetName);
      fetch(`${Constants.API}change_user_info.php`, {
        credentials: "include",
        method: "POST",
        body: formData,
        headers: {
          "X-XSRF-Header": Constants.XSRF,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (!("error" in res)) {
            dispatch({ type: "changeSnapChatName", payload: debouncedSetName });
          }
        })
        .catch((_) => console.log("weird error saving snapchat name"));
    }
  }, [debouncedSetName, dispatch]);

  useEffect(() => {
    if (commentNameRef.current !== debouncedSetCommentName) {
      commentNameRef.current = debouncedSetCommentName;
      let formData = new FormData();
      formData.append("cName", debouncedSetCommentName);
      fetch(`${Constants.API}change_comment_name.php`, {
        credentials: "include",
        method: "POST",
        body: formData,
        headers: {
          "X-XSRF-Header": Constants.XSRF,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if (!("error" in res)) {
            dispatch({
              type: "changeCommentName",
              payload: debouncedSetCommentName,
            });
          }
        })
        .catch((_) => console.log("weird error saving snapchat name"));
    }
  }, [debouncedSetCommentName, dispatch]);

  return (
    <div className="general_page">
      <div className="wrapper_field">
        <div className="headline_panel">
          <h2 className="title profile active small">Profile</h2>
          <h2 className="title profile">
            <Link to={`${Constants.MA}messages`}>Messages</Link>
          </h2>
          <i className="icon-moon" onClick={themeState.toggle} />
          <a href="https://addfriends.com/logout">
            <i className="icon-exit" />
          </a>
        </div>
        <div className="form_field">
          <form action="#">
            <div className="row">
              <div className="col">
                <label htmlFor="email" className="label">
                  Email
                </label>
              </div>
              <div className="col second">
                <div className="icon">
                  <i className="icon-email" />
                </div>
                <input
                  type="text"
                  className="input"
                  value={username}
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="sp_name" className="label">
                  Display Name
                </label>
              </div>
              <div
                className={
                  isCNEditing
                    ? "col second grid_control edit"
                    : "col second grid_control"
                }
              >
                <div className="icon">
                  <i className="icon-message" />
                </div>
                <input
                  type="text"
                  className="input input_control"
                  value={commentName}
                  onFocus={() => setIsCNEditing(true)}
                  onBlur={() => setIsCNEditing(false)}
                  onChange={(e) => setCommentName(e.target.value)}
                />
                <div className="hide_accept">
                  <i className="icon-save" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="sp_name" className="label">
                  Private Account
                </label>
              </div>
              <div
                className={
                  isEditing
                    ? "col second grid_control edit"
                    : "col second grid_control"
                }
              >
                <div className="icon">
                  <i className="icon-snap" />
                </div>
                <input
                  type="text"
                  className="input input_control"
                  value={name}
                  onFocus={() => setEditing(true)}
                  onBlur={() => setEditing(false)}
                  onChange={(e) => setName(e.target.value)}
                />
                <div className="hide_accept">
                  <i className="icon-save" />
                </div>
              </div>
            </div>
            <div className="bottom">
              <Link to={`${Constants.MA}what-is-premium`}>
                Where do i find my snapname?
              </Link>
            </div>
          </form>
        </div>
        <div className="notifications">
          <div className="notification">
            <div>email notifications (click to change)</div>
            {email === "y" ? (
              <button
                className="emailNotifications"
                onClick={handleChangeEmailNotes}
              >
                &#10003; Email Notifications are <strong>ENABLED!</strong>
              </button>
            ) : (
              <button
                className="emailNotifications donot"
                onClick={handleChangeEmailNotes}
              >
                &times; Email Notifications are <strong>DISABLED!</strong>
              </button>
            )}
          </div>
          {swSupport ? (
            isSubscribed && push === "y" ? (
              <div className="notification">
                <div>push notifications (click to change)</div>
                <button
                  className="emailNotifications"
                  onClick={unsubscribeUser}
                >
                  &#10003; Push Notifications are <strong>ENABLED!</strong>
                </button>
              </div>
            ) : (
              <div className="notification">
                <div>push notifications (click to change)</div>
                <button
                  className="emailNotifications donot"
                  onClick={subscribeUser}
                >
                  &times; Push Notifications are <strong>DISABLED!</strong>
                </button>
              </div>
            )
          ) : (
            <div className="notification">
              <div>Push notifications disabled</div>
              <button className="emailNotifications nosupport">
                &times; no support on device
              </button>
            </div>
          )}
        </div>
        <FAQ />
        <ManageMemberships dispatch={dispatch} />
      </div>
    </div>
  );
};

export default Profile;
